<template>
  <a href="/plugindownload/master/" target="_blank" class="download-button__link" @click="logDownloadPluginBIMLIBMaster">
    <bim-button :label="title" class="download-button__button" />
  </a>
</template>

<script>
import bimButton from "@bimlib/components/bimButton"
import { logDownloadPluginBIMLIBMaster } from "@/utils/logEvents.js"
export default {
  name: "DownloadButton",
  components: {
    bimButton
  },
  props: {
    title: {
      type: String,
      default: "Скачать мастер спецификаций",
    }
  },
  methods: {
    logDownloadPluginBIMLIBMaster,
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.download-button__link {
  display: block;

  .download-button__button {
    padding: 21px 24px;
    font-size: 18px;
    font-weight: bold;
    line-height: 1.44;
    height: auto;

    @media screen and (max-width: $breakpoint-sm) {
      padding: 12px 15px;
      font-size: 12px;
    }
  }
}
</style>
